// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutHiringNavbar-cls1_1oI","cls2":"AboutHiringNavbar-cls2_i2o AboutHiringNavbar-cls1_1oI"};